module.exports = __webpack_public_path__ + "img/motoroil-big.a9d4b7bf.png";